export const CONFIRM_WALLET = "WALLET/CONFIRM";
export const CHECK_WALLET = "WALLET/CHECK";
export const EXIT_WALLET = "WALLET/EXIT";
